import React from 'react';

const Nurse = () => {
  return (
    <div 
      className="relative flex items-center justify-center h-[85vh] lg:min-h-screen bg-cover bg-center md:px-10"
      style={{
        backgroundImage: "url('/hospital.jpg')",
      }}
    >
      {/* Background Blur Overlay */}
      <div className="absolute inset-0 bg-white/30 backdrop-blur-sm"></div>

      {/* Content Box - Shift Left Without Affecting Image */}
      <div className="boxdiv relative z-10   bg-white max-h-[90%] p-6 md:p-10 rounded-lg shadow-lg  max-w-full m-5 md:max-w-[90%] lg:ml-16 lg:-mr-72">
        <h1 className="text-[25px] md:text-[48px] font-bold">
          <span className="text-pink-600">Free Recruitment</span> <span className="text-black">for Nurses!</span>
        </h1>

        <ul className="mt-2 text-md md:text-lg">
          <li>🔷 100% Free Processing - No Fees!</li>
          <li>🔷 Earn ₹2 Lakhs+ Monthly in Germany!</li>
          <li>🔷 PR/Citizenship in Just 4 Years!</li>
          <li>🔷 Secure & Stable Nursing Career!</li>
        </ul>

        <div className="mt-6 flex flex-col md:flex-row gap-2  md:w-xl max-w-full">
         <div className='w-full md:w-1/2 flex items-center justify-center'>
          <h1 className="font-semibold text-xl ">Who Can Apply?</h1>
     </div>
          <div className="grid  mt-2 grid-cols-3  gap-2 border-2 border-gray-300 p-3 rounded-md text-center text-sm md:text-base">
            <div className="border-r border-gray-300 ">BSc/GNM <br />Nursing</div>
            <div className="border-r border-gray-300">Age below <br />35</div>
            <div >Freshers & Experienced</div>
          </div>
        </div>
      </div>
      
      {/* Nurse Image - Move Left Without Resizing */}
      <div className="absolute  -left-20 md:left-[-5px] bottom-0 lg:w-1/2 w-[75%] md:w-[50%] h-full pointer-events-none z-20">
            <img 
            src='/nurse.png' 
            alt="Nurse" 
            className="absolute left-0 md:-left-10 sm:w-[100%] h-[30%] bottom-0 md:bottom-0 md:w-full lg:h-[100%] md:h-[35%] object-cover "
            />
      </div>
    </div> 
  );
};

export default Nurse;
